// extracted by mini-css-extract-plugin
export default {"navigation":"navigation-oC0T1","useInternalScroll":"useInternalScroll-Jit4l","horizontalNav":"horizontalNav-FyUga","blackAndWhite":"blackAndWhite-dFGRd"};